import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import RehabPrivacy from './screens/RehabPrivacy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<RehabPrivacy />} />
        <Route path='/rehab' element={<RehabPrivacy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
